<amg-loader *ngIf="loading || !showContent"></amg-loader>
<ng-container *ngIf="appReady">
  <app-header *ngIf="wpCommonData"
              [wpCommonData]="wpCommonData"></app-header>
  <main [class.show]="showContent"
        class="show-smoothly"
        id="page-container">
    <router-outlet></router-outlet>
  </main>
  <app-footer *ngIf="wpCommonData"
              [wpCommonData]="wpCommonData"></app-footer>
  <app-login-modal *ngIf="wpCommonData"
                   [wpCommonData]="wpCommonData"></app-login-modal>
</ng-container>
